import { z } from 'zod';

export const productFormSchema = z.object({
  name: z.string().min(1, 'Name is required').max(256, 'Name must be less than 256 characters'),
  tagline: z.string().max(256, 'Tagline must be less than 256 characters').optional().or(z.literal('')),
  description: z.string().max(5000, 'Description must be less than 5000 characters').optional().or(z.literal('')),
  categoryId: z.string().optional(),
  status: z.enum(['operational', 'beta', 'maintenance']).default('operational'),
  icon: z.string().max(256, 'Icon must be less than 256 characters').optional().or(z.literal('')),
  url: z.union([z.url('Please enter a valid URL'), z.literal('')]).optional(),
  features: z.array(z.string()).default([]),
  targetUsers: z.array(z.string()).default([]),
  slackChannels: z.array(z.string()).default([]),
  contactPerson: z
    .object({
      name: z.string().optional().or(z.literal('')),
      email: z.union([z.email('Please enter a valid email'), z.literal('')]).optional(),
      role: z.string().optional().or(z.literal('')),
    })
    .optional(),
  metrics: z.record(z.any(), z.any()).default({}),
});

export type ProductFormData = z.infer<typeof productFormSchema>;
